import React, { useEffect } from "react";

// Root route. Renders a brief splash so Safari can fetch manifest.json + register
// the service worker before we leave "/", then redirects. Runs before any auth checks.
export default function RootRedirect() {
  useEffect(() => {
    const t = setTimeout(() => {
      window.location.href = "/login";
    }, 150);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      data-testid="root-redirect-splash"
      className="flex min-h-screen items-center justify-center bg-slate-900"
    >
      <img src="/icon-192.png" alt="RallyPointGo" className="h-16 w-16 rounded-2xl" />
    </div>
  );
}
